import { call, put, takeEvery } from 'redux-saga/effects'

import { exportApi } from '../../api/exportApi'
import { SCHEDULE_EXPORT } from '../actions/export'
import { exportActions } from '../slices/export'

function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}

function* scheduleExportSaga(action) {
    const { groupId, groupName, saveOnServer } = action.payload

    if (!groupId) {
        yield put(exportActions.setError('Пожалуйста, выберите группу для экспорта.'))
        return
    }

    try {
        yield put(exportActions.setExporting(true))
        yield put(exportActions.setError(null))

        if (saveOnServer) {
            yield call(exportApi.saveOnServer, groupId)
            yield put(exportActions.setNotice(`Расписание группы ${groupName || groupId} сохранено на сервере`))
            return
        }

        const { blob, fileName } = yield call(exportApi.downloadSchedule, groupId)
        downloadBlob(blob, fileName || `${groupName || groupId}.xlsx`)
    } catch (error) {
        console.error('EXPORT ERROR:', error)
        yield put(exportActions.setError(
            error instanceof Error ? error.message : 'Расписания для данной группы не найдено'
        ))
    } finally {
        yield put(exportActions.setExporting(false))
    }
}

function* scheduleExportWatch() {
    yield takeEvery(SCHEDULE_EXPORT, scheduleExportSaga)
}

export default function* exportRootSaga() {
    yield scheduleExportWatch()
}
